<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    {{pageTitle}}
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2">
                <div class="content mb-0">
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : timer.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="timer.title" @input="v$.timer.title.$touch()" :class="{invalid:v$.timer.title.$error}">
                        <p class="text-danger" v-if="v$.timer.title.required.$invalid && v$.timer.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>


                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.fullTitle }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="timer.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="card mx-0 mb-3">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars show" id="collapse-description">
                            <textarea v-model="timer.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
                        </div>
                    </div>
                    <button type="button" v-if="!timer.regist" :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="AddOrEditWorkTimer">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>

                    <button type="button" v-if="timer.id!=null && timer.id!=0 && timer.regist && timer.otherWorkId==null" :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="WorkTimerInsertOtherWork">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت فعالیت
                    </button>

                </div>
            </div>


            <div v-if="timer.folderList.length>0" class="card bg-20 mt-3 mb-n4 content pt-3 pb-5 shadow-l mx-0" style="z-index:0">
                <div class="card-body d-flex justify-content-between">
                    <span class="color-white font-22">تایمرها</span>
                </div>
                <div class="card-overlay bg-highlight opacity-95 shadow-l"></div>
                <div class="card-overlay dark-mode-tint shadow-l"></div>
            </div>

            <div :class="{'bg-Start' : item.lastStatus ,'bg-Regist' : item.regist}" class="card card-style mt-n5" v-for="item in timer.folderList" :key="item.folderId" style="margin-bottom:60px;">
                <div class="content mb-0">
                    <div class="input-style input-style-2 mb-2">
                        <input class="form-control" type="text" @change="SetFolderTitleVal(item)" :id="item.folderId" :value="item.title">
                    </div>
                    <ul class="list-group list-group-flush rounded-sm mb-3">
                        <li class="list-group-item p-2">
                            زمان شروع:<b class="text-muted d-inline-block text-left ltr float-left">{{item.startDateTimeFa}}</b>
                        </li>
                        <li class="list-group-item p-2">
                            زمان پایان:<b class="text-muted d-inline-block text-left ltr float-left">{{item.endDateTimeFa}}</b>
                        </li>
                        <li class="list-group-item p-2">
                            زمان استفاده شده:<b class="text-muted d-inline-block text-left ltr float-left">{{item.workTime}}</b>
                        </li>
                    </ul>
                    <att-list v-if="timer.id!=0" v-bind:destination="'WorkTimer'" @setAttList="SetAttList(item.attList,item)" :canAdd="true" :canDelete="true" :oldAttList="item.attList" :hasLocation="true"></att-list>
                </div>
            </div>
        </div>

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading || pageLoaded" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
    </div>
    <Create-OtherWork v-if="openCreateOtherWorkModal" v-bind:ItemId="timer.id" @close="CloseCreateOtherWorkModal"></Create-OtherWork>
</template>

<script>
    import useVuelidate from '@vuelidate/core';
    import {
        required
    } from "@vuelidate/validators";
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    import CreateOtherWork from '../Components/CreateOtherWork.vue';
    import AttList from '../Components/AttList.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu,
            "Create-OtherWork": CreateOtherWork,
            "att-list": AttList,
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                openCreateOtherWorkModal: false,
                folderTitle: "",
                pageTitle: "",
                itemId: 0,
                folderId: 0,
                pageLoaded: false,
                attList: [],
                timer: {
                    id: null,
                    title: null,
                    description: null,
                    regist: false,


                    otherWorkId: null,
                    otherWorkTypeId: null,
                    personId: null,//
                    projectId: null,//
                    invoiceId: null,//
                    preInvoiceId: null,//
                    contractId: null,//
                    letterId: null,//
                    meetingId: null,//
                    preBuyInvoiceId: null,
                    buyId: null,//
                    folderList: [],

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                    isLoad: false,
                },
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        watch: {
            'timer.personId'(value) {
                if (this.timer.isLoad)
                    this.onchangePerson();
            },
            'timer.projectId'(value) {
                if (this.timer.isLoad)
                    this.onchangeProject();
            },
            'timer.preInvoiceId'(value) {
                if (this.timer.isLoad)
                    this.onchangePreInvoice();
            },
            'timer.contractId'(value) {
                if (this.timer.isLoad)
                    this.onchangeContract();
            },
            'timer.meetingId'(value) {
                if (this.timer.isLoad)
                    this.onchangeMeeting();
            },
            'timer.invoiceId'(value) {
                if (this.timer.isLoad)
                    this.onchangeInvoice();
            },
            'timer.letterId'(value) {
                if (this.timer.isLoad)
                    this.onchangeLetter();
            },
            'timer.buyId'(value) {
                if (this.timer.isLoad)
                    this.onchangeBuy();
            },
        },
        created() {
            if (this.$route.params.id != null && this.$route.params.id != 0) {
                this.pageTitle = "ویرایش زمانسنج(تایمر)";
                this.GetTimerItem(this.$route.params.id);
            }
            else {
                this.pageTitle = "افزودن زمانسنج(تایمر)";
                this.$store.dispatch("GetPersonListFromServer", {});
                this.$store.dispatch("GetProjectListFromServer", {});
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
                this.$store.dispatch("GetContractAbstractForPerson", {});
                this.$store.dispatch("GetInvoiceAbstractForPerson", {});
                this.$store.dispatch("GetLetterAbstractForPerson", {});
                this.$store.dispatch("GetMeetingAbstractForPerson", {});
                this.$store.dispatch("GetBuyAbstractForPerson", {});
                this.timer.isLoad = true;
            }
        },
        validations: {
            timer: {
                title: {
                    required,
                }
            }
        },

        methods: {
            SetAttList(attList, item) {
                let attObj = null;
                this.attList = attList;
                for (var i = 0; i < attList.length; i++) {
                    attObj = attList[i];
                }
                attObj.folderAttId = 0;
                attObj.folderId = item.folderId;
                console.log(attObj);
                this.$store.dispatch("CreateWorkTimerFolderAtt", attObj);
            },
            SetFolderTitleVal(item) {
                item.title = (document.getElementById(item.folderId).value);
                this.$store.dispatch("WorkTimerFolderEdit", item);
            },
            GetTimerItem(id) {
                this.pageLoaded = true;
                this.$http.get("WorkTimer/GetById?id=" + id)
                    .then(data => {
                        if (data.data == null || data.data.id == null || data.data.id == 0) {
                            this.pageTitle = "افزودن زمانسنج(تایمر)";
                            this.$store.dispatch("GetPersonListFromServer", {});
                            this.$store.dispatch("GetProjectListFromServer", {});
                            this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
                            this.$store.dispatch("GetContractAbstractForPerson", {});
                            this.$store.dispatch("GetInvoiceAbstractForPerson", {});
                            this.$store.dispatch("GetLetterAbstractForPerson", {});
                            this.$store.dispatch("GetMeetingAbstractForPerson", {});
                            this.$store.dispatch("GetBuyAbstractForPerson", {});
                            this.timer.isLoad = true;
                            this.pageLoaded = false;

                        } else {
                            this.$store.dispatch("GetPersonListFromServer", {
                                text: "",
                                personId: data.data.personId,
                            }).then(a => {

                                this.$store.dispatch("GetProjectListFromServer", {
                                    text: "",
                                    personId: data.data.personId,
                                    projectId: data.data.projectId,
                                }).then(b => {
                                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                                        text: "",
                                        personId: data.data.personId,
                                        preInvoiceId: data.data.preInvoiceId,
                                    }).then(c => {
                                        this.$store.dispatch("GetContractAbstractForPerson", {
                                            personId: data.data.personId,
                                            projectId: data.data.projectId,
                                            contractId: data.data.contractId,
                                        }).then(d => {
                                            this.$store.dispatch("GetInvoiceAbstractForPerson", {
                                                invoiceId: data.data.invoiceId,
                                                preInvoiceId: data.data.preInvoiceId,
                                                contractId: data.data.contractId,
                                                personId: data.data.personId,
                                            }).then(e => {
                                                this.$store.dispatch("GetLetterAbstractForPerson", {
                                                    letterId: data.data.letterId,
                                                    personId: data.data.personId,
                                                }).then(f => {
                                                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                                                        personId: data.data.personId,
                                                        contractId: data.data.contractId,
                                                        projectId: data.data.projectId,
                                                        meetingId: data.data.meetingId,
                                                    }).then(g => {
                                                        this.$store.dispatch("GetBuyAbstractForPerson", {
                                                            personId: data.data.personId,
                                                            prebuyInvoiceId: data.data.prebuyInvoiceId,
                                                            buyId: data.data.buyId,
                                                            contractId: data.data.contractId,
                                                        }).then(h => {
                                                            this.timer = data.data;
                                                            this.pageLoaded = false;
                                                            this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                                                                .then(data => {
                                                                    this.timer.isLoad = true;
                                                                });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        }
                    });




            },
            AddOrEditWorkTimer() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.$store.dispatch("WorkTimerAddOrEdit", this.timer);
                }
            },
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.timer.projectId = null;
                this.timer.invoiceId = null;
                this.timer.preInvoiceId = null;
                this.timer.contractId = null;
                this.timer.letterId = null;
                this.timer.meetingId = null;
                this.timer.preBuyInvoiceId = null;
                this.timer.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.timer.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.timer.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.timer.contractId = null;
                this.timer.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.timer.personId,
                    projectId: this.timer.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.timer.personId,
                    projectId: this.timer.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.timer.personId,
                        projectId: this.timer.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.timer.contractId = null;
                this.timer.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.timer.preInvoiceId,
                    contractId: this.timer.contractId,
                    personId: this.timer.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.timer.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.timer.invoiceId = null;
                this.timer.buyId = null;
                this.timer.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.timer.preInvoiceId,
                    contractId: this.timer.contractId,
                    personId: this.timer.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.timer.personId,
                    projectId: this.timer.projectId,
                    contractId: this.timer.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.timer.personId,
                    prebuyInvoiceId: this.timer.prebuyInvoiceId,
                    contractId: this.timer.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.timer.preInvoiceId,
                        contractId: this.timer.contractId,
                        personId: this.timer.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.timer.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.timer.personId,
                        contractId: this.timer.contractId,
                        projectId: this.timer.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.timer.personId,
                        prebuyInvoiceId: this.timer.prebuyInvoiceId,
                        contractId: this.timer.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },
            CloseCreateOtherWorkModal() {
                this.openCreateOtherWorkModal = false;
            },
            StartTimeWorkTimer() {
                this.$http
                    .get(
                        "WorkTimer/StartTime?id=" +
                        this.itemId
                    )
                    .then((data) => {
                        if (data.data.isSuccess) {
                            this.$store.dispatch("GetWorkTimerListFromServer", {});
                        } else {
                            this.showErrorMessage(data.data.Message);
                        }
                    })
            },
            StopTimeWorkTimer(id) {
                this.$http
                    .get(
                        "WorkTimer/StopTime?id=" +
                        this.itemId
                    )
                    .then((data) => {
                        if (data.data.isSuccess) {
                            this.$store.dispatch("GetWorkTimerListFromServer", {});
                        } else {
                            this.showErrorMessage(data.data.Message);
                        }
                    })
            },
            RegistWorkTimer() {
                VueSimpleAlert.confirm("آیا مایل به اتمام این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    //Regist
                    this.$http
                        .get(
                            "WorkTimer/Regist?id=" +
                            this.itemId
                        )
                        .then((data) => {
                            if (data.data.isSuccess) {
                                this.$store.dispatch("GetWorkTimerListFromServer", {});
                            } else {
                                this.showErrorMessage(data.data.Message);
                            }
                        })
                });
            },
            ShowAttList() {
                var btnShowModal = document.getElementById("btnattListModal");
                btnShowModal.click();
                document.getElementsByClassName('menu-hider')[0].click();
            },
            showMenu(item) {
                this.folderId = item.folderId;
                this.attList = item.attList;
                this.folderTitle = item.title;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            WorkTimerInsertOtherWork() {
                this.openCreateOtherWorkModal = true;
            },
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
